import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "users-page" }
const _hoisted_2 = { class: "users-page__main" }
const _hoisted_3 = { class: "users-page__content" }
const _hoisted_4 = { class: "users-page__content-top" }
const _hoisted_5 = { class: "users-page__search-filter" }
const _hoisted_6 = { class: "users-page__first-l-upper" }
const _hoisted_7 = { class: "users-page__pagination" }
const _hoisted_8 = { class: "users-page__side" }

import { ref, reactive, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Search } from "@element-plus/icons-vue";
import { EmptyData } from "@/shared/ui/components/EmptyData";
import { ViewInspector } from "@/shared/ui/components/ViewInspector";
import { ElMessage } from "element-plus";
import { IUsers, IUser } from "@/shared/types/users";


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersPage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const loading = ref<boolean>(false);
const currentId = ref<string | null>(null);

const filter = reactive({
  email: "",
  page: 1,
});

const users = computed<IUsers>(() => {
  return store.state.users.data;
});

const list = computed<IUser[]>(() => {
  return users.value.data;
});

const user = computed(() => {
  if (currentId.value) {
    const item =
      list.value.find((user: IUser) => user.uuid === currentId.value) || {};
    return item;
  } else {
    return {};
  }
});

const subscriptions = computed(() => {
  return user.value.subscriptions;
});

onMounted(async () => {
  try {
    await getUsers();
    currentId.value = list.value[0].uuid;
    try {
      await getUser(currentId.value);
    } catch (e: any) {
      ElMessage({
        message: e,
        type: "error",
      });
    }
  } catch (e: any) {
    ElMessage({
      message: e,
      type: "error",
    });
  }
});

const getUsers = async () => {
  loading.value = true;
  await store.dispatch("users/getUsers", {
    email: filter.email,
    page: filter.page,
  });
  loading.value = false;
};

const handleRefresh = async () => {
  loading.value = true;
  await store.dispatch("users/refreshUser", { user_uuid: currentId.value });
  if (currentId.value) {
    await getUser(currentId.value);
  }
  await getUsers();
  loading.value = false;
};

const handleToggleVip = async () => {
  loading.value = true;
  console.log("handle toggleVip");
  console.log(currentId.value);
  await store.dispatch("users/toggleVip", { user_uuid: currentId.value });
  if (currentId.value) {
    await getUser(currentId.value);
  }
  await getUsers();
  loading.value = false;
};

const getUser = async (id: string) => {
  return await store.dispatch("users/getUser", id);
};

const getTypeByStatus = (status: string) => {
  switch (status) {
    case "vip":
      return "primary";
    case "expired":
      return "danger";
    case "active":
      return "success";
    case "none":
      return "info";
    default:
      return "info";
  }
};

const onClickCeil = (item: IUser) => {
  currentId.value = item.uuid;
  getUser(currentId.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "users-page__top" }, [
      _createElementVNode("div", { class: "users-page__title" }, "Users")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              modelValue: filter.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.email) = $event)),
              placeholder: "Search",
              size: "small",
              clearable: "",
              style: {"width":"240px"},
              onClear: getUsers,
              onKeypress: _withKeys(getUsers, ["enter"])
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              size: "small",
              onClick: getUsers
            }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_component_el_table, {
          data: list.value,
          height: "100%",
          style: {"width":"100%","border-radius":"4px"},
          onRowClick: onClickCeil
        }, {
          empty: _withCtx(() => [
            _createVNode(_unref(EmptyData), { class: "permissions-page__table-empty" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "#",
              width: "70"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "email",
              label: "Email"
            }),
            _createVNode(_component_el_table_column, {
              prop: "subscription_type",
              label: "Subscription Type"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(scope.row.subscription_type || "-"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "Status",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  class: "users-page__first-l-upper",
                  type: getTypeByStatus(scope.row.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.status || "None"), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_pagination, {
            layout: "prev, pager, next",
            "current-page": filter.page,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((filter.page) = $event)),
            total: users.value.total,
            "page-size": 20,
            background: "",
            onCurrentChange: getUsers
          }, null, 8, ["current-page", "total"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(ViewInspector), {
          field: user.value,
          vip: user.value.is_vip,
          onOnRefresh: handleRefresh,
          onOnToggleVip: handleToggleVip
        }, null, 8, ["field", "vip"])
      ])
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})